import { FC, useState } from 'react';
import { Skeleton } from 'antd';
import { Container, Wrapper } from './styles';
import { Tooltip } from '../Tooltip/Tooltip';
import { ReactComponent as CloseEdit } from '../../assets/icon-edit.svg';

type ChartSkeletonProps = {
  id?: string;
  title: JSX.Element | string;
  footer?: JSX.Element | string;
  sidebarLegend?: JSX.Element | string;
  loading?: boolean;
  isPreview?: boolean;
  chartTitle?: string;
  isUtilizationChart?: boolean;
};

export const ChartLoading = () => {
  return (
    <div className="relative">
      <Wrapper>
        <div className="relative">
          <Skeleton.Input active />
        </div>
        <Container>
          <Skeleton active />
        </Container>
      </Wrapper>
    </div>
  );
};

export const ChartSkeleton: FC<ChartSkeletonProps> = ({
  title,
  children,
  footer,
  sidebarLegend,
  loading,
  id,
  isPreview,
  isUtilizationChart,
  chartTitle,
}) => {
  const [updatedChartTitle, setUpdatedChartTitle] = useState(chartTitle);
  const [editMode, setEditMode] = useState(false);

  return (
    <div className="relative w-full h-full">
      <Wrapper isPreview={isPreview}>
        <div className="relative">{title}</div>
        <Tooltip
          title={isPreview && 'Exported Image Boundary'}
          builtinPlacements={{
            top: {
              // i.e: Align the bottom center of the tooltip to the top-center of the target element
              points: ['bc', 'tc'],
              offset: [200, 0],
            },
          }}
        >
          <div
            id={id}
            className={`flex ${isPreview && 'flex-col'} h-full pb-4 ${
              isPreview &&
              'overflow-hidden border transition-all duration-600 border-dashed border-white hover:border-gray-500 group'
            }`}
          >
            {isPreview && (
              <div className="col-span-3 row-span-1 h-11">
                {!editMode && (
                  <>
                    <div
                      className="text-4xl text-gray-600 -mb-4 font-bold text-center z-100 cursor-text h-16 flex items-center justify-center"
                      onClick={() => setEditMode(true)}
                    >
                      {updatedChartTitle}

                      <Tooltip title="Click to edit title" placement="bottomLeft">
                        <span className="invisible group-hover:visible ml-3 cursor-pointer">
                          <CloseEdit fill="#717171" />
                        </span>
                      </Tooltip>
                    </div>
                  </>
                )}
                {editMode && (
                  <input
                    type="text"
                    autoFocus
                    value={updatedChartTitle}
                    className="border-none outline-none focus:ring-0 text-center text-4xl text-gray-600 font-bold w-full -mb-5 h-16"
                    onChange={(e) => setUpdatedChartTitle(e.target.value)}
                    onBlur={() => setEditMode(false)}
                  />
                )}
              </div>
            )}
            {/* <div className="col-span-2 row-span-1 bg-rose-300"> */}
            <div className="flex flex-col flex-grow min-h-0 overflow-hidden">
              <Container isPreview={isPreview}>
                {loading ? <Skeleton active /> : children}
              </Container>
              <div className="footer min-h-[50px]">{footer}</div>
            </div>
            {sidebarLegend && !isPreview && (
              <div className="flex w-[10%] pt-16 justify-end items-end">
                <div className="mb-[90px] ">{sidebarLegend}</div>
              </div>
            )}
            {isPreview && isUtilizationChart && (
              <div className={`${isPreview && 'flex flex-row justify-center pl-12'} min-h-[50px]`}>
                {/* {sidebarLegend} */}
                <img src="/assets/utilization-modality-legend.png" className="h-16" />
              </div>
            )}
          </div>
        </Tooltip>
      </Wrapper>
    </div>
  );
};
